var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aisea-operation-report-show flex flex-col overflow-x-auto"},[_c('operation-report-show-body',{ref:"operationReportShowBody",style:(_vm.cssVariables),attrs:{"aoEnterpriseCsvs":_vm.aoEnterpriseCsvs}}),_c('operation-report-show-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }